import { SearchSVG } from '@sbercloud/uikit-product-icons';
import { LayoutType } from '@sbercloud/uikit-product-utils';
import { Typography } from '@snack-uikit/typography';
import { useAnalytics } from 'src/hooks/useAnalytics';

import s from './HeaderSearchInput.module.scss';

export function HeaderSearchInput({
  onClick,
  layoutType,
}: {
  onClick(): void;
  active?: boolean;
  layoutType: LayoutType;
}) {
  const { clickAnalytics } = useAnalytics();

  const handleSearchClick = () => {
    onClick();
    clickAnalytics({
      action: 'click',
      clickZone: 'header',
      clickElement: 'textclick',
      clickContent: 'Поиск',
      uniqueId: `header-search-input-click`,
      transitionType: 'inside-link',
      clickZoneCategory: 'site-header',
      transitionTypeMetrics: 'internal',
    });
  };

  return (
    <div className={s.button} onClick={handleSearchClick}>
      <SearchSVG size={24} />
      {layoutType !== 'mobile' && (
        <Typography.SansLabelM>Поиск</Typography.SansLabelM>
      )}
    </div>
  );
}
